const ComponentWithMetadataRelationMixin = {
    props: {
        relationString: {
            type: String,
        },
    },
    computed: {
        /**
         * Get the current relation strign
         * @returns {*}
         */
        currentRelationString() {
            let relation = this.getRelationStringObject();
            relation.shift();
            return relation.join(':');
        },
    },
    methods: {
        /**
         * relationStringObject
         *
         * @return {*|boolean}
         */
        getRelationStringObject() {
            let relationString = this.relationString;

            if(! relationString) {
                return false;
            }

            return relationString.split(':');
        },
        /**
         * Go to meta data route
         *
         * @param relationAddon
         */
        goToRoute(relationAddon) {
            let params = Object.assign({}, this.$route.params);
            if(params.relationString != undefined) {
                params.relationString += ':' + relationAddon;
            } else {
                params.relationString = relationAddon;
            }

            this.$router.push({
                name: this.$route.name,
                params: params,
                query: this.$route.query
            });
        },
        /**
         * Close the stacked window by going back
         */
        goToPreviousRoute() {
            let currentRelationStringIndex = this.$route.params.relationString.indexOf(this.relationString);

            // if the relationString index is bigger then 0 this means it is inside a bigger relationString
            // then we need to move back 1 extra spot to also remove the : from the relation string
            currentRelationStringIndex = currentRelationStringIndex > 0
                ? currentRelationStringIndex - 1
                : currentRelationStringIndex;

            const leftOverRelationString = this.$route.params.relationString.substring(0, currentRelationStringIndex);

            this.$router.push({
                ...this.$route,
                params: {
                    ...this.$route.params,
                    relationString: leftOverRelationString ? leftOverRelationString : null
                }
            });
        }
    },
    created() {
    }
}

export default ComponentWithMetadataRelationMixin;